module.exports = "<p>\n  This is Frequently asked questions\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./client/views/faq/faq.component.html
// module id = ./client/views/faq/faq.component.html
// module chunks = main